import { FormControl, TextField } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import validation, { createSchemaValidation } from "../../utilities/validation";
import UploadFile from "./UploadFile";

const Form = ({ fields, onSubmit, isSending, isSuccess }) => {
  const [data, setData] = useState({});
  const [schemaValidation, onChangeSchemaValidation] = useState();
  const [errorList, changeErrorList] = useState({});

  const initialFormData = useCallback(() => {
    let fieldData = {};
    fields.forEach(
      (item) => (fieldData[item.name] = item?.defaultValue || null)
    );
    setData(fieldData);
    if (fields.length > 1) {
      onChangeSchemaValidation(
        createSchemaValidation(
          fields.map((element) => ({
            name: element.name,
            type: element.type,
            isRequired: element.isRequired,
          }))
        )
      );
    }
  }, [fields]);

  useEffect(() => {
    initialFormData();
  }, [fields, initialFormData]);

  const onClickSubmit = (e) => {
    e.preventDefault();
    const valid = validation(data, schemaValidation);
    changeErrorList(valid);
    if (!valid) {
      onSubmit(data);
    }
  };

  useEffect(() => {
    isSuccess && initialFormData();
  }, [isSuccess, initialFormData]);

  return (
    <form onSubmit={onClickSubmit}>
      <FormControl className="w-100 row">
        {fields.map((field, index) => (
          <div key={field.key} className={"col-12 px-0 mb-4"}>
            {field.type !== "file" ? (
              <TextField
                label={field.label}
                value={data[field.name] || ""}
                variant="outlined"
                onChange={(e) =>
                  setData((prevState) => ({
                    ...prevState,
                    [e.target.name]: e.target.value,
                  }))
                }
                type={field.type}
                error={errorList?.[field.name]}
                helperText={errorList?.[field.name]}
                name={field.name}
                inputProps={{ style: { fontSize: 12, padding: 12 } }} // font size of input text
                InputLabelProps={{ style: { fontSize: 12, marginTop: "-2px" } }}
                className="w-100"
              />
            ) : (
              <UploadFile
                label={field.label}
                value={data[field.name] || ""}
                type={field.type}
                file_type={field.file_type}
                name={field.name}
                error={errorList?.[field.name]}
                helperText={errorList?.[field.name]}
                onChange={(e) =>
                  setData((prevState) => ({
                    ...prevState,
                    [e.target.name]: e.target.value,
                  }))
                }
                className="w-100"
              />
            )}
          </div>
        ))}
        <div className={"col-12 px-0 text-start"}>
          <button
            className="btn py-2 px-5 rounded text-16 bg-green text-background"
            disabled={isSending}
          >
            ارسال
          </button>
        </div>
      </FormControl>
    </form>
  );
};

export default Form;
